import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from '@bos/ui';
import { setZodErrorMap } from './setZodErrorMap';
export const createZodTranslationProvider = ({ useErrorMessages, useDefaultErrorMessage, }) => {
    const ZodTranslationProvider = ({ children }) => {
        const errorMessages = useErrorMessages();
        const defaultErrorMessage = useDefaultErrorMessage();
        setZodErrorMap({ errorMessages, defaultErrorMessage });
        return _jsx(Box, { children: children });
    };
    return ZodTranslationProvider;
};
